import { render, staticRenderFns } from "./newspaper-form-template.vue?vue&type=template&id=be090c48&"
import script from "./newspaper-form-template.vue?vue&type=script&lang=js&"
export * from "./newspaper-form-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports